export const Routes = {
    EXTRACT_APP_URL: 'extract',
    EXPORT_ROUTE: 'export',
    FILTER_DATA_ROUTE: 'export/filter-data',
    CONFIGURE_DATA_ROUTE: 'export/configure-data',
    SAVE_AND_EXTRACT_ROUTE: 'export/save-and-extract',
    SUCCESS_ROUTE: 'export/success',
    ACCOUNT_ROUTE: 'account',
    DOWNLOADS_ROUTE: 'my-downloads',
    LOGOUT_ROUTE: 'logout',
    PAGE_NOT_FOUND_ROUTE: 'page-not-found',
    SYSTEM_ERROR: 'system-error',
    SEARCH_INFO_GRAPHIC: 'search',
    SEARCH_ROUTE: 'search',
    INSIGHTS_INFO_GRAPHIC: 'insights',
    ABOUT_EUROMONITOR: 'about-euromonitor',
    SKU_SEARCH: 'search',
    SKU_SEARCH_SKU: 'search/sku',
    SKU_SEARCH_RESULTS: 'search/results',
    SKU_SEARCH_CONFIGURE_DATA_ROUTE: 'search/configure-data',
    SKU_SEARCH_SAVE_AND_EXTRACT_ROUTE: 'search/save-and-extract',
    SKU_SEARCH_PRICE_HISTORY: 'search/price-history',
    BROWSER_SUPPORT: 'help/browser-support',
    CONTACT_US: 'help/contact-us',
    GET_STARTED: 'help/get-started',
    VIDEO_TUTORIALS: 'help/video-tutorials',
    FAQ: 'help/faq',
    DEFINITIONS: 'help/definitions',
    METHODOLOGY: 'help/methodology',
};
